import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function AgendaPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>
      <Header header={'Agenda'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'CriarAgenda'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Criar Agenda'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'VerAgendasDisponiveis'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Ver Agendas Disponiveis'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'VerAgendasMarcadas'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Ver Agendas Marcadas'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />

    </>
  )
}
